import type { EstiloId } from '@/invitation/payload/types';

/**
 * 011 — URL de la vista previa de una variante de estilo para el wizard.
 *
 * Apunta a la ruta pública `/invitations/demo/:estilo` (sin auth ni BD), que renderiza la
 * invitación v2 real con contenido de ejemplo. Sobrescribe SOLO los nombres reales de los
 * novios (lo único "real" del preview); el resto del contenido es de muestra.
 *
 * Se carga dentro de un `<iframe>` (viewport propio → las unidades `vw` del render resuelven
 * al ancho del iframe, dando una miniatura fiel al escalar).
 */
export function buildStylePreviewUrl(
  estiloId: EstiloId,
  brideName?: string,
  groomName?: string,
): string {
  const params = new URLSearchParams();
  const bride = brideName?.trim();
  const groom = groomName?.trim();
  if (bride) params.set('bride', bride);
  if (groom) params.set('groom', groom);
  const query = params.toString();
  return `/invitations/demo/${estiloId}${query ? `?${query}` : ''}`;
}
